export default __webpack_public_path__ + "static/media/ebook-01.6ba2d09a.png";